import { useSurveyResponsesQuery } from 'documents/surveyResponses.generated';

export const useSurveyResponses = (surveyId: string) => {
  const { data: surveyData, loading: isSurveyLoading } = useSurveyResponsesQuery({
    variables: { surveyId },
  });

  return { surveyData, isSurveyLoading };
};
